export default __webpack_public_path__ + "static/media/g-8.2d46ffde.jpg";